export const paragraphTemplate = {
  '_template': 'paragraph',
  'paragraph': {
    es: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.',
    en: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.'
  },
  'text': {
    'fontSize': {
      'xl': 16
    },
    'bold': {
      'xl': 'medium'
    },
    'textColor': {
      'xl': '#737373'
    },
    'align': {
      'xl': 'center'
    }
  },
  'box': {
    'size': {
      'maxWidth': {
        'xl': 580
      }
    },
    'margin': {
      'marginTop': {
        'xl': 20,
        'xs': 10
      }
    }
  }
};
